<template>
    <div v-if="isShow && category.productgroups.length">
      <div :class="'ticket-wrap ' + wavveVoucherClass(category.passgroup_type)">
        <div class="ticket-inner-wrap">
          <h3 :class="'m-ticket-title ' + titleColor(category.passgroup_type)">
            {{ category.passgroup_name }}
          </h3>

          <all-product-groups-new v-for="(data, index) in category.productgroups" :key="''+ categoryIndex + index"
                              :group-info="data"
                              :category-name="category.passgroup_name"
                              :product-type="category.passgroup_type"
                              :group-index="categoryIndex +'_'+ index"
                              :user-line="userLine"
                              :set-number-commas="setNumberCommas"
                              :category-index="categoryIndex"
                              :current-index="currentIndex"/>
        </div>
      </div>
    </div>
</template>

<script>
import utils from '@/common/util/utils'
import AllProductGroupsNew from '@/components/voucher/AllProductGroupsNew'

export default {
  components: {
    AllProductGroupsNew
  },
  props: {
    category: {
      type: Object,
      required: true
    },
    userLine: {
      type: String
    },
    setNumberCommas: {
      type: Function
    },
    isPlayy: {
      type: String
    },
    currentIndex: {
      type: String
    },
    categoryIndex: {
      type: Number
    }
  },
  data () {
    return {
      device: utils.cookies.getDevice()
    }
  },
  computed: {
    isShow () {
      return this.category
    }
  },
  methods: {
    titleColor (type) {
      return type === 'one' || type === 'package' ? 'one' : type === 'wavve_option' ? 'bugs' : ''
    },
    wavveVoucherClass (productType) {
      return productType === 'voucher' ? 'wavve-voucher' : ''
    }
  }
}
</script>
